import React from 'react';
import { Icon } from 'semantic-ui-react';

import { useDispatch, useSelector } from 'react-redux';
import { ActivityPopup } from 'shared/forms/NewActivity';
import SendEmailModal from 'shared/modals/SendEmailModal';
import sendEmailActions from 'actions/send_email';

const EmailIcon = ({ onClose, onOpenEmailModal, onOpenActivityPopup, isActivityFormOpen, contact_id, account_id, hasEmail, isEmailModalOpen, emailIconClassName }) => {
    const hasEmailIntegrations = useSelector(state => state.oauth_integrations.integrations?.length > 0);
    const dispatch = useDispatch();
    const account = useSelector(state => ({ account: state.send_email.account_modal?.account }));
    return (
        <React.Fragment>
            {hasEmail ?
                hasEmailIntegrations ? <Icon className={`${emailIconClassName} fa-solid fa-envelope`} link onClick={() => {
                    if (contact_id) {
                        dispatch(sendEmailActions.readModalContact(contact_id));
                        dispatch(sendEmailActions.getModalLocations(contact_id));
                    } else if (account_id) {
                        dispatch(sendEmailActions.readModalAccount(account_id));
                    }
                    onOpenEmailModal();
                }} /> :
                    <ActivityPopup
                        trigger={
                            <Icon className={`${emailIconClassName} fas fa-envelope`} link />
                        }
                        activityProps={{
                            readTimeline: () => { },
                            contact: { id: contact_id || null },
                            account: { id: account_id },
                            isContact: contact_id ? true : false,
                            emailOnly: true
                        }}
                        open={isActivityFormOpen}
                        onOpen={onOpenActivityPopup}
                        onClose={onClose}
                        position="bottom right"
                    />
                : <Icon className={`${emailIconClassName} fa-solid fa-envelope`} link disabled />
            }
            <SendEmailModal
                open={isEmailModalOpen}
                onClose={onClose}
                {...(account_id ? { loadedAccount: account, isAccountModal: true } : {})}
                {...(contact_id ? { contact_id } : {})}
            />
        </React.Fragment>
    );
};

export default EmailIcon;

